import axios from 'axios'
import { useEffect, useState } from 'react'

/**
 * Return users from provided divisions, or all users if no division provided
 * @divisionIds array of division IDs
 */
const useUsersForSelect = (hasExecutive = false) => {
  const [data, setData] = useState([])
  const [divisionIds, setDivisionIds] = useState([])

  useEffect(() => {
    fetchUsers(divisionIds)
  }, [divisionIds])

  const fetchUsers = async (divisionIds) => {
    const url = hasExecutive ? '/users/for-select' : '/users/for-select-limited'
    let response = []
    if (divisionIds.length > 0) {
      response = await axios.get(url, { params: { divisionIds: divisionIds } })
    } else {
      response = await axios.get(url)
    }
    setData(response.data || [])
  }

  return { data, setDivisionIds, divisionIds }
}
export default useUsersForSelect
